import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import EventView from './components/EventView';
import EventRegistration from './components/EventRegistration';
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    setIsLoggedIn(!!token);
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsLoggedIn(false);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/admin"
            element={
              isLoggedIn ? (
                <AdminDashboard onLogout={handleLogout} />
              ) : (
                <Login onLoginSuccess={handleLogin} />
              )
            }
          />
          <Route path="/event/:id" element={<EventView />} />
          <Route path="/event/:id/invite" element={<EventRegistration />} />
          <Route path="/" element={<Navigate to="/admin" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
